<span class="icon help-icon-wrap" *ngIf="!autoTrigger" ngbTooltip="Help" placement="right" (click)="open(helpGuide)"><i class="icon-help"></i></span>

<ng-template #helpGuide let-c="close" let-d="dismiss">
    <div class="tour-start-modal">
        <div class="modal-header">
            <h4 class="modal-title">Cira Help Docs</h4>
            <div class="right-cntrl-icons">
                <button class="help-doc-minimize" ngbTooltip="Minimize" placement="bottom" (click)="minimizeHelpDoc()"><span class="iconB-minus-square"></span></button>

                <button class="help-doc-minimize"  ngbTooltip="Resize window" placement="bottom" (click)="maximizeHelpDoc()"><span class="icon iconB-min-max-window"></span></button>

                <button type="button" class="close" ngbTooltip="Close" placement="bottom" aria-label="Close" (click)="d('Cross click')">
                    <i _ngcontent-c46="" class="icon icon-cira"></i>
            </button>
            </div>
        </div>

        <div class="modal-body">
            <div class="iframe-wrap">
                <iframe [src]="docUrl" height="500" width="1000" title="description"></iframe>
            </div>
        </div>
    </div>
</ng-template>

<div class="help-doc-max-wrap" ngDraggable [inBounds]="true" [handle]="DragItem" *ngIf="helpdocStatus">
    <div class="doc-max-container">
        <div class="doc-max-title">
            <span class="iconB-draggable"></span>
            <h1 class="title mb-0">Help</h1>
        </div>
        <div class="right-cntrl-icons">
            <button class="help-doc-minimize" (click)="open(helpGuide)"><span class="iconB-min-max-window"></span></button>
            <button type="button" class="close" aria-label="Close" (click)="closeHelpBlock()">
        <span class="close-btn" aria-hidden="true">&times;</span>
    </button>
        </div>
    </div>
</div>